
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppButton',
  emits: ['btnClicked'],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    btnIcon: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      iconClasses: `fas fa-${ this.btnIcon }`
    }
  },
  methods: {
    emitClick(): void {
      this.$emit('btnClicked')
    }
  }
});
